import isEmpty from "lodash-es/isEmpty"
import map from "lodash-es/map"

import {
    EAssistantParticipantStatus,
    type IAssistanceParticipantDto,
    type IAssistanceParticipantModel
} from "./assistant.participants.api.types"

export default {
    participants(dtos: IAssistanceParticipantDto[]): IAssistanceParticipantModel[] {
        return isEmpty(dtos)
            ? []
            : map<IAssistanceParticipantDto, IAssistanceParticipantModel>(
                  dtos,
                  (dto: IAssistanceParticipantDto): IAssistanceParticipantModel => ({
                      id: dto.id,
                      firstName: dto.first_name,
                      lastName: dto.last_name,
                      photo: dto.photo,
                      unscheduledSessionsCount: dto.unscheduled_sessions_count,
                      registrationDeadline: dto.registration_deadline,
                      status: ((): EAssistantParticipantStatus => {
                          switch (dto.status) {
                              case "needs_registration":
                                  return EAssistantParticipantStatus.NoRegistration
                              case "no_next_session":
                                  return EAssistantParticipantStatus.NoNextSession
                              case "sessions_to_schedule":
                                  return EAssistantParticipantStatus.SessionsToSchedule
                              case "all_scheduled":
                                  return EAssistantParticipantStatus.AllScheduled
                              case null:
                              default:
                                  return null
                          }
                      })()
                  })
              )
    }
}
